(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["misaj-announcement"] && !Shopify.designMode) return;
  try {
    
  /* Countdown. One interval for the whole page, re-querying the DOM on every tick, so a
     block the merchant adds or edits in the theme editor is picked up on its own without
     any re-binding. This lives here rather than in an inline <script> for that reason:
     an inline tag re-executes on each section re-render and stacked up a fresh interval
     every time a setting was touched. */
  (function () {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    /* The separator belongs to the countdown that follows it, so it goes too — otherwise
       hiding the timer leaves a stray "·" floating between the other blocks. */
    function hide(el) {
      el.hidden = true;
      var sep = el.previousElementSibling;
      if (sep && sep.classList.contains('announce-sep')) sep.hidden = true;
    }
    function units(el) {
      // Translated by Liquid and handed over as attributes; the fallbacks only matter
      // if the markup is ever rendered without them.
      return {
        d: el.getAttribute('data-unit-days') || 'D',
        h: el.getAttribute('data-unit-hours') || 'H',
        m: el.getAttribute('data-unit-minutes') || 'M'
      };
    }
    function tick(el) {
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      var out = el.querySelector('.announce-cd-time');
      if (!out) return;
      /* A date the browser cannot parse — a typo, or a format Safari rejects that Chrome
         accepts — would otherwise leave the placeholder dash sitting in the bar forever.
         Treat it as nothing to show rather than as a broken timer. */
      if (isNaN(end)) {
        hide(el);
        return;
      }
      var u = units(el);
      var diff = end - Date.now();
      if (diff <= 0) {
        // Liquid already omits an expired countdown; this only catches a page left
        // open across the end time.
        if (el.hasAttribute('data-countdown-hide')) {
          hide(el);
        } else {
          out.textContent = '0' + u.d + ' 00' + u.h + ' 00' + u.m;
        }
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      out.textContent = d + u.d + ' ' + pad(h) + u.h + ' ' + pad(m) + u.m;
    }
    function run() { document.querySelectorAll('[data-countdown]').forEach(tick); }
    run();
    setInterval(run, 1000);
  })();

  (function () {
    // Mouse-like pointers only. On a touchscreen a `pointerdown` fires while the page
    // is being scrolled past the strip, and if the matching `pointerup` lands elsewhere
    // the marquee stays frozen — which is why it looked dead on phones.
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('[data-marquee]').forEach(function (track) {
      if (track.dataset.marqueeBound) return;
      track.dataset.marqueeBound = '1';
      var pause = function () { track.classList.add('is-paused'); };
      var resume = function () { track.classList.remove('is-paused'); };
      // Press and hold pauses; release resumes.
      track.addEventListener('pointerdown', pause);
      track.addEventListener('pointerup', resume);
      track.addEventListener('pointercancel', resume);
      track.addEventListener('pointerleave', resume);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["misaj-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function bind() {
      document.querySelectorAll('.misaj .faq details').forEach(function (details) {
        var summary = details.querySelector('summary');
        var content = details.querySelector('p');
        if (!summary || !content) return;
        if (details.dataset.faqBound) return;
        details.dataset.faqBound = '1';

        summary.addEventListener('click', function (e) {
          if (reduce) return; // let the browser toggle instantly
          e.preventDefault();
          if (details.dataset.animating) return;

          var opening = !details.open;
          details.dataset.animating = '1';
          if (opening) details.open = true;

          var from = opening ? 0 : content.scrollHeight;
          var to = opening ? content.scrollHeight : 0;
          content.style.overflow = 'hidden';

          // The answer's bottom padding is a setting now, so the height animation has to
          // end on whatever it is set to — a hard-coded 22px would snap at the last frame
          // for any other value. Custom properties inherit, so this reads the section's.
          var pad = getComputedStyle(details).getPropertyValue('--faq-row-pad').trim() || '22px';
          var padFrom = opening ? '0px' : pad;
          var padTo = opening ? pad : '0px';

          var anim = content.animate(
            [
              { height: from + 'px', paddingBottom: padFrom, opacity: opening ? 0 : 1 },
              { height: to + 'px', paddingBottom: padTo, opacity: opening ? 1 : 0 }
            ],
            { duration: 280, easing: 'ease' }
          );

          anim.onfinish = function () {
            content.style.overflow = '';
            if (!opening) details.open = false;
            delete details.dataset.animating;
          };
        });
      });
    }

    bind();
    /* The theme editor re-renders just this section when a setting changes, replacing
       each <details> with a fresh copy that carries no handler — without this the smooth
       open silently reverts to a snap for the rest of the editing session. Re-scanning is
       safe to repeat: `faqBound` skips anything already wired. */
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["misaj-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function bind() {
      document.querySelectorAll('.misaj .pingr-inci').forEach(function (details) {
        var summary = details.querySelector('summary');
        var content = details.querySelector('.pingr-inci__body');
        if (!summary || !content) return;
        if (details.dataset.inciBound) return;
        details.dataset.inciBound = '1';

        summary.addEventListener('click', function (e) {
          if (reduce) return; // let the browser toggle instantly
          e.preventDefault();
          if (details.dataset.animating) return;

          var opening = !details.open;
          details.dataset.animating = '1';
          if (opening) details.open = true; // must be open to be measurable

          var cap = parseFloat(window.getComputedStyle(content).maxHeight);
          var full = content.scrollHeight;
          var open = isFinite(cap) ? Math.min(full, cap) : full;

          var from = opening ? 0 : open;
          var to = opening ? open : 0;
          content.style.overflow = 'hidden';

          var padFrom = opening ? '0px' : '20px';
          var padTo = opening ? '20px' : '0px';

          var anim = content.animate(
            [
              { height: from + 'px', paddingBottom: padFrom, opacity: opening ? 0 : 1 },
              { height: to + 'px', paddingBottom: padTo, opacity: opening ? 1 : 0 }
            ],
            { duration: 280, easing: 'ease' }
          );

          anim.onfinish = function () {
            content.style.overflow = '';
            if (!opening) details.open = false;
            delete details.dataset.animating;
          };
        });
      });
    }

    bind();
    /* The theme editor re-renders just this section when a setting changes, which
       replaces the <details> with a fresh copy that has no handler on it — without
       this the smooth open silently reverts to a snap for the rest of the editing
       session. Re-scanning is safe to repeat: `inciBound` skips anything already
       wired. */
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["misaj-intro"] && !Shopify.designMode) return;
  try {
    
  /* Carousel controls. The track scrolls natively, so this script only has to keep the bar in
     step with it, move the track when a segment is clicked, and let a mouse drag the frames the
     way a finger already can.

     Delegated per section rather than bound once: the theme editor replaces a section's markup
     wholesale when a setting changes, and anything bound to the old nodes would be left holding
     elements that are no longer on the page. */
  (function () {
    function initCard(track) {
      if (track.dataset.pcardBound) return;
      track.dataset.pcardBound = '1';

      var card = track.closest('.pcard-inner') || document;
      var dotsWrap = card.querySelector('[data-pcard-dots]');
      var slides = track.querySelectorAll('.pcard-slide');
      var dots = dotsWrap ? dotsWrap.querySelectorAll('.pcard-dot') : [];
      if (!slides.length) return;

      var current = 0;
      /* While a move of our own is easing, the track passes over every frame in between.
         Reading the index off those would run the marker along the bar as it travelled, so
         following the scroll is held off until the animation has had its time. A hand on the
         track clears the hold immediately. */
      var followAfter = 0;

      function mark(i) {
        current = i;
        dots.forEach(function (d) {
          var active = Number(d.dataset.index) === i;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function goTo(i) {
        if (i < 0) i = 0;
        if (i > slides.length - 1) i = slides.length - 1;
        var target = slides[i];
        if (!target) return;
        var delta = target.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
        followAfter = Date.now() + 650;
        mark(i);
      }

      /* Which frame is nearest the middle of the viewport, rather than which one starts
         closest to the left edge: with snapping set to `center` those are not the same
         answer, and the second one flips a frame early. */
      function nearest() {
        var mid = track.getBoundingClientRect().left + track.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (s, i) {
          var r = s.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          if (Date.now() < followAfter) return;
          var i = nearest();
          if (i !== current) mark(i);
        });
      }, { passive: true });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          followAfter = 0;
          goTo(Number(dot.dataset.index));
        });
      });

      /* Press and move is a swipe; press and release without moving is a click that opens the
         product. The two share a gesture, so they are told apart by distance: 8px is past the
         wobble of a hand on a trackpad or a thumb on glass, and well short of anything anyone
         means as a drag.
         `dragged` outlives the gesture on purpose — a mouse drag is followed by a click event,
         and without the flag every swipe would also navigate. */
      var DRAG_SLOP = 8;
      var dragged = false;

      /* Touch scrolls the track by itself, so the pointer handlers below are for mouse-like
         pointers only; binding them for touch would fight the browser's own gesture. A tap that
         becomes a scroll fires no click at all, so the flag is not needed there. */
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        var down = false, startX = 0, startScroll = 0, moved = 0;
        track.addEventListener('pointerdown', function (e) {
          down = true; moved = 0; dragged = false;
          startX = e.clientX;
          startScroll = track.scrollLeft;
          followAfter = 0;
          track.classList.add('is-dragging');
        });
        track.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > moved) moved = Math.abs(dx);
          if (moved > DRAG_SLOP) dragged = true;
          track.scrollLeft = startScroll - dx;
        });
        function endDrag() {
          if (!down) return;
          down = false;
          track.classList.remove('is-dragging');
          /* Barely moved: treat it as a click and snap back rather than creep to a neighbour. */
          goTo(moved < DRAG_SLOP ? current : nearest());
        }
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('pointerleave', endDrag);
      }

      var href = track.dataset.pcardHref;
      if (href) {
        track.classList.add('is-linked');
        track.addEventListener('click', function () {
          if (dragged) { dragged = false; return; }
          window.location.href = href;
        });
      }

      mark(0);
    }

    function scan() {
      document.querySelectorAll('[data-pcard-track]').forEach(initCard);
    }
    scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["misaj-partners"] && !Shopify.designMode) return;
  try {
    
  /* Delegated from the document, not bound to the form when this runs.

     Section JavaScript is served as one bundle that can execute while the page is still being
     parsed, and this section is at the very bottom of it: looked up on load, the form was
     often not in the document yet, nothing got bound, and the submit went to the server the
     ordinary way — which reloads the page and lands on `?contact_posted=true#MisajPartnersForm`,
     jumping the window to the anchor. Delegation has no such window to miss, and it needs no
     re-binding when the theme editor replaces the section's markup.

     The guard is against the bundle being evaluated twice: a second listener would post the
     form twice and send two emails. */
  if (!window.misajPartnersFormBound) {
    window.misajPartnersFormBound = true;

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('mpart__form')) return;
      var section = form.closest('[data-mpart]');
      if (!section) return;
      // Let the browser run its own validation first; only a valid form is intercepted.
      if (!form.checkValidity()) return;
      event.preventDefault();

      var button = form.querySelector('button');
      var input = form.querySelector('input[type="email"]');
      if (button) button.disabled = true;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
      })
        .then(function (response) {
          // The reply is checked before anything is claimed: this form sends a mail someone is
          // waiting on, so a failed post must not be answered with a thank you. A rejected post
          // falls through to the same handler as a dropped connection.
          if (!response.ok) throw new Error('contact form rejected');
          // The whole field goes, not just its controls, or an empty box is left behind.
          var field = form.querySelector('.mpart__field');
          if (field) field.style.display = 'none';
          var old = form.querySelector('.mpart__note');
          if (old) old.remove();
          var note = document.createElement('p');
          note.className = 'micro mpart__note';
          note.setAttribute('role', 'status');
          note.textContent = section.dataset.success || '';
          form.appendChild(note);
        })
        .catch(function () {
          // Handed back to the visitor to try again — and if scripting is the thing that failed
          // them, the form still posts to the server on a second submit.
          if (button) button.disabled = false;
          if (input) input.focus();
        });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["misaj-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Pausing is bound only for mouse-like pointers. On a touchscreen a `pointerdown`
    // fires when the page is scrolled past the strip, and if the matching `pointerup`
    // lands elsewhere the marquee stays frozen — which is why it looked dead on phones.
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('[data-marquee]').forEach(function (track) {
      if (track.dataset.marqueeBound) return;
      track.dataset.marqueeBound = '1';
      var pause = function () { track.classList.add('is-paused'); };
      var resume = function () { track.classList.remove('is-paused'); };
      track.addEventListener('pointerdown', pause);
      track.addEventListener('pointerup', resume);
      track.addEventListener('pointercancel', resume);
      track.addEventListener('pointerleave', resume);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["misaj-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var area = document.querySelector('.misaj-reviews');
    if (!area) return;
    var host = area.querySelector('.misaj-reviews__app');

    function hasContent() {
      if (!host) return false;
      return host.textContent.trim().length > 0 || host.offsetHeight > 20;
    }

    // The area starts visible on purpose. Review widgets load lazily off their
    // container's visibility, so hiding it up front is a deadlock: a display:none
    // host never enters the viewport, the widget never initialises, nothing is ever
    // rendered, and the class that hid it never comes back off. Collapsing is
    // therefore only ever done once, after the widget has had a fair chance.
    function collapseIfStillEmpty() {
      if (hasContent()) return;
      area.classList.add('is-empty');
    }
    function reveal() {
      if (hasContent()) area.classList.remove('is-empty');
    }

    if (host && 'MutationObserver' in window) {
      new MutationObserver(reveal).observe(host, { childList: true, subtree: true });
    }
    window.addEventListener('load', function () {
      setTimeout(collapseIfStillEmpty, 3000);
    });

    // Open the review form directly from the product panel's "Write a review" link.
    // Each review app names its own trigger, so try the known ones and otherwise
    // leave the plain anchor scroll alone.
    var FORM_TRIGGERS = [
      '.jdgm-write-rev-link', // Judge.me
      '.oke-bttn-primary', // Okendo
      '.stamped-write-review-tab', // Stamped
      '.yotpo-new-review-btn', // Yotpo
      '[data-review-form-trigger]' // generic opt-in hook
    ];
    function findFormTrigger() {
      for (var i = 0; i < FORM_TRIGGERS.length; i++) {
        var el = document.querySelector(FORM_TRIGGERS[i]);
        if (el) return el;
      }
      return null;
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('.misaj-pdp__review-link');
      if (!link) return;
      var formBtn = findFormTrigger();
      if (!formBtn) return; // no app form yet — fall back to the plain anchor scroll
      event.preventDefault();
      area.classList.remove('is-empty');
      area.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () { formBtn.click(); }, 400);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["misaj-voices"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Mouse-like pointers only. On a touchscreen a `pointerdown` fires while the page
    // is being scrolled past the strip, and if the matching `pointerup` lands elsewhere
    // the marquee stays frozen — which is why it looked dead on phones.
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('[data-marquee]').forEach(function (track) {
      if (track.dataset.marqueeBound) return;
      track.dataset.marqueeBound = '1';
      var pause = function () { track.classList.add('is-paused'); };
      var resume = function () { track.classList.remove('is-paused'); };
      // Press and hold pauses; release resumes.
      track.addEventListener('pointerdown', pause);
      track.addEventListener('pointerup', resume);
      track.addEventListener('pointercancel', resume);
      track.addEventListener('pointerleave', resume);
    });
  })();

  (function () {
    // Every photograph in the strip is marked `loading="lazy"`, and a lazy image decides
    // whether to load from where it sits in the page — a judgement it makes once and does
    // not revisit when a container carries it sideways. Only the two or three tiles that
    // happen to start near the viewport ever load; measured here, three of sixteen. The rest
    // scroll into view as empty squares, which reads as the reel running out of reviews.
    //
    // So the moment the strip is near the screen, its images are told to load now. That is
    // still late enough to cost nothing on arrival — the section sits well down the page —
    // and the second copy of the reel names the same files as the first, so what looks like
    // sixteen pictures is eight requests.
    function loadPhotos(strip) {
      if (strip.dataset.photosLoaded) return;
      strip.dataset.photosLoaded = '1';
      strip.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
        // Safari has been known to ignore the property change on an image it has already
        // passed over; re-assigning the source is what actually starts the fetch there.
        if (!img.complete && img.src) img.src = img.src;
      });
    }

    function watch(strip) {
      if (!('IntersectionObserver' in window)) { loadPhotos(strip); return; }
      // A screen's worth of margin, so the pictures are there before the strip is.
      new IntersectionObserver(function (entries, obs) {
        if (!entries[0].isIntersecting) return;
        loadPhotos(strip);
        obs.disconnect();
      }, { rootMargin: '600px 0px' }).observe(strip);
    }

    document.querySelectorAll('.voice-marquee').forEach(watch);
  })();

  (function () {
    // Below 840px the CSS animation is off and the strip is a scroll container instead, so
    // the movement is driven here by scrolling it. The reason is not preference: an animated
    // element becomes one composited layer as wide as its whole content — sixteen tiles twice
    // over, some 8,000 pixels, which on a 3x phone is past what iOS will allocate, and past
    // it the layer is simply never painted. A scroll container has no such layer; the browser
    // paints the part in view and nothing else.
    //
    // The loop works by recycling, not by running along two copies of the reel.
    //
    // That is the second attempt. The first laid out the reel twice, scrolled through the
    // pair and jumped back by one copy's width at the seam — which depends on the scroll
    // offset it asks for being the offset it gets. On a phone that turned out not to hold:
    // the strip reached the end of the track and stopped there with nothing beside it, over
    // and over, whatever the wrap arithmetic said. Rather than keep guessing at which of the
    // measurements was lying, this drops the assumption entirely.
    //
    // Now the first tile is moved to the back of the row the moment it has fully passed the
    // left edge, and the scroll offset is reduced by exactly its width in the same breath —
    // so nothing appears to move, and the row is one tile further round. The offset therefore
    // never travels beyond a single tile's width, which means it can never approach the end
    // of the track and there is no end to arrive at. It is also why one copy is now enough:
    // the second is hidden on a phone, halving both the DOM and the width of the thing being
    // painted.
    var mq = window.matchMedia ? window.matchMedia('(max-width: 840px)') : null;
    var still = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    document.querySelectorAll('.voice-marquee').forEach(function (strip) {
      if (strip.dataset.autoScrollBound) return;
      strip.dataset.autoScrollBound = '1';

      var set = strip.querySelector('.voice-set');
      // The second, `aria-hidden` copy of the reel. Kept or dropped by `measure` below.
      var spare = strip.querySelectorAll('.voice-set')[1];
      var SPEED = 38; // px per second, matched to the desktop marquee's apparent pace
      var last = 0;
      var raf = 0;
      var held = false;
      var onScreen = true;
      var resumeTimer = 0;
      // The position is kept here and written out whole, rather than added to `scrollLeft`
      // each frame. A frame's worth of this speed is about a quarter of a pixel, and a
      // scroll offset is not stored that finely — added straight on, every step rounds away
      // to nothing and the strip never moves at all. Measured: 290 frames, zero pixels.
      var pos = 0;
      var tile = 0;

      // The width of one tile, measured when the layout changes and kept.
      //
      // One number covers every tile in the row: the photograph and the card beside it are
      // both `flex: 0 0 var(--voice-w)`, so they are the same width by construction and the
      // first one measured describes all of them.
      //
      // It used to be read inside the animation frame — an `offsetWidth`, sixty times a
      // second, immediately before writing `scrollLeft`. Reading an element's width forces
      // the browser to lay the strip out there and then, and writing the scroll offset
      // invalidates that layout again: read, write, read, write, every frame. That is the
      // judder. A marquee cannot run smoothly while it asks for a reflow to decide where to
      // go next, and the answer never changes between frames anyway.
      function measure() {
        var first = set ? set.firstElementChild : null;
        tile = first ? first.offsetWidth : 0;

        // The duplicate reel is dead weight once the row recycles: the offset never travels
        // beyond a single tile, so the eye never reaches as far as the copy. Hidden, that
        // halves both the DOM and the width the phone is asked to paint.
        //
        // With one condition. One copy has to be wider than the window plus a tile, or the
        // offset will ask to scroll further than the container is able to and be clamped —
        // and a clamped offset is a strip that stops moving. Eight testimonials clear that
        // by a mile; one does not, and a merchant is free to leave one. So it is measured
        // rather than assumed, and the copy stays whenever it is still carrying its weight.
        if (spare) {
          var enough = tile > 0 && set.children.length * tile >= strip.clientWidth + tile;
          spare.style.display = mq && mq.matches && enough ? 'none' : '';
        }
      }

      // Sends every tile that has gone past the left edge to the back of the row, taking its
      // width off the offset as it goes so the picture does not shift. A loop rather than a
      // single step because a swipe can carry the strip several tiles in one gesture.
      function recycle() {
        var guard = 0;
        while (tile > 0 && pos >= tile && set.firstElementChild && guard < 64) {
          set.appendChild(set.firstElementChild);
          pos -= tile;
          guard += 1;
        }
      }

      function shouldRun() {
        return mq && mq.matches && !(still && still.matches) && !held && onScreen;
      }

      function step(now) {
        raf = 0;
        if (!shouldRun()) { last = 0; return; }
        if (tile > 0) {
          var dt = last ? Math.min((now - last) / 1000, 0.05) : 0;
          pos += SPEED * dt;
          // Recycled before the offset is written, so the row is already in its new order by
          // the time the browser is asked to scroll to the matching place. The other way
          // round, the two are a frame apart and the seam flickers.
          recycle();
          strip.scrollLeft = pos;
        }
        last = now;
        raf = requestAnimationFrame(step);
      }

      function start() { if (!raf && shouldRun()) { last = 0; raf = requestAnimationFrame(step); } }
      function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } last = 0; }

      // Only a real sideways drag takes the strip over. Touching it does not: `touchstart`
      // fires for a tap, and for the moment a finger rests here on its way down the page,
      // and pausing on those made the reel stop for no reason a reader could see. So the
      // start of a touch is only remembered, and the hold waits until the finger has
      // actually travelled sideways — at which point the swipe is unmistakably deliberate.
      var startX = 0;
      var dragging = false;

      function hold() { held = true; dragging = true; stop(); clearTimeout(resumeTimer); }
      function release() {
        if (!dragging) return; // a tap: nothing was ever paused, so nothing to resume
        dragging = false;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          // Pick up from wherever the swipe left it, or the first frame would snap the strip
          // back to where the script had got to before the finger landed. A gesture can carry
          // the strip several tiles along, so the row is wound forward to match before the
          // offset is trusted again — `recycle` brings both back within one tile's width.
          pos = strip.scrollLeft;
          recycle();
          strip.scrollLeft = pos;
          held = false;
          start();
        }, 1200);
      }

      strip.addEventListener('touchstart', function (e) {
        startX = e.touches && e.touches[0] ? e.touches[0].clientX : 0;
      }, { passive: true });
      strip.addEventListener('touchmove', function (e) {
        if (dragging) return;
        var x = e.touches && e.touches[0] ? e.touches[0].clientX : startX;
        // Eight pixels is past a thumb's wobble on a tap and well short of a real swipe.
        if (Math.abs(x - startX) > 8) hold();
      }, { passive: true });
      strip.addEventListener('touchend', release, { passive: true });
      strip.addEventListener('touchcancel', release, { passive: true });

      // Off screen it should not be burning a frame budget it cannot be seen spending.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          onScreen = entries[0].isIntersecting;
          onScreen ? start() : stop();
        }, { threshold: 0 }).observe(strip);
      }
      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : start();
      });

      // The breakpoint and the motion preference can both change while the page is open.
      var recheck = function () { stop(); pos = 0; strip.scrollLeft = 0; measure(); start(); };
      if (mq && mq.addEventListener) mq.addEventListener('change', recheck);
      if (still && still.addEventListener) still.addEventListener('change', recheck);

      // Turning a phone sideways is not a breakpoint change — it stays under 840px — but the
      // tile is sized partly in `vw`, so a copy is a different width afterwards and the
      // measurement above is stale. Nothing was watching for that. Deferred to the next
      // frame because the new dimensions are not settled at the moment the event fires, and
      // rate-limited to one measurement per frame so a slow drag of a desktop window does
      // not queue hundreds of reflows.
      var remeasure = 0;
      window.addEventListener('resize', function () {
        if (remeasure) return;
        remeasure = requestAnimationFrame(function () {
          remeasure = 0;
          measure();
        });
      }, { passive: true });

      measure();
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
